import { render } from "./MonthlyProfit.vue?vue&type=template&id=2b1a1bc6&scoped=true&ts=true"
import script from "./MonthlyProfit.vue?vue&type=script&lang=ts"
export * from "./MonthlyProfit.vue?vue&type=script&lang=ts"

import "./MonthlyProfit.vue?vue&type=style&index=0&id=2b1a1bc6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1a1bc6"]])

export default __exports__